module.exports = __webpack_public_path__ + "static/DSC_9308-148f4cc64832499a1055a6a938a3e449.jpg";